import request from "@/utils/request";

// 登录
export function login(data) {
  return request({
    url: "/api/hp-user/login",
    method: "POST",
    data
  });
}

// 登录是否校验验证码
export function checkCaptcha(params) {
  return request({
    url: "/api/cross-paas/check-captcha",
    method: "get",
    params
  });
}


export function logout() {
  return request({
    url: "/api/hp-user/login-out",
    method: "get"
  });
}

// 获取验证码
export function flat(params) {
  return request({
    url: "/api/captcha/flat?" + params,
    method: "get",
    responseType:"blob"
  });
}
//shouyin
export function permissions(store_id) {
    return request({
        url: '/api/cross-paas/cashier/permissions',
        method: 'get',
        params: { store_id }
    });
}
//shouyin
export function checklogin() {
    return request({
        url: 'api/cross-paas/check-login-status',
        method: 'get',
        
    });
}


// 登录
export function googlelogin(data) {
  return request({
    url: "/api/hp-user/google-login",
    method: "post",
    data
  });
}


// 注册
export function register(data) {
  return request({
    url: "/api/hp-user/register",
    method: "post",
    data
  });
}



// 获取个人信息
export function myinfo() {
    return request({
        url: '/api/hp-user/my-info',
        method: 'get',
        
    });
}

export function myinfopublic(params) {
    return request({
        url: '/api/public/my-info',
        method: 'get',
        params
    });
}

// 获取验证信息

export function sendverify(data) {
  return request({
    url: "/api/hp-user/send-verify",
    method: "post",
    data
  });
}


// 通过邮编获取地址
export function getcityaddress(params) {
    return request({
        url: '/api/hp-user/getcityaddress',
        method: 'get',
        params
    });
}


export function userupdate(data) {
  return request({
    url: "/api/hp-user/my-info/update",
    method: "post",
    data
  });
}

export function userResetPassword(data) {
  return request({
    url: "/api/hp-user/reset-pwd",
    method: "post",
    data,
  });
}

export function getpolicytoken(params) {
    return request({
        url: '/api/oss/getpolicytoken',
        method: 'get',
        params
    });
}


// 验证账号是否登录
export function sendverifyregister(params) {
    return request({
        url: '/api/hp-user/send-verify-register',
        method: 'get',
        params
    });
}
export function updatebank(data) {
  return request({
    url: "/api/hp-user/my-info/update-bank",
    method: "post",
    data
  });
}


export function updateaccount(data) {
  return request({
    url: "/api/hp-user/my-info/update-account",
    method: "post",
    data
  });
}



export function addbank(data) {
  return request({
    url: "/api/hp-user/my-info/add-bank",
    method: "post",
    data
  });
}

export function noticeconfig(data) {
  return request({
    url: "/api/hp-user/my-info/notice-config",
    method: "post",
    data
  });
}



export function deletebank(data) {
  return request({
    url: "/api/hp-user/my-info/delete-bank",
    method: "post",
    data
  });
}

// 验证账号是否存在
export function checkverifycodebyaccount(data) {
  return request({
    url: "/api/hp-user/checkverifycodebyaccount",
    method: "post",
    data
  });
}

// 发送邮箱验证
export function loginv2(data) {
  return request({
    url: "/api/hp-user/email-login-v2",
    method: "post",
    data
  });
}

export function registerv2(data) {
  return request({
    url: "/api/hp-user/email-register-v2",
    method: "post",
    data
  });
}

// 忘记密码 - 发送验证码
export function forgotPasswordSend(data) {
  return request({
    url: "/api/hp-user/forget-pwd",
    method: "post",
    data
  });
}

// 忘记密码 - 验证验证码
export function   forgotPasswordVerify(data) {
  return request({
    url: "/api/hp-user/check-forget-pwd-code",
    method: "post",
    data
  });
}

// 忘记密码 - 重置密码
export function resetPassword(data) {
  return request({
    url: "/api/hp-user/forget-new-pwd",
    method: "post",
    data
  });
}


// ACTIVATION ONLY--------------------------------------------------
export function registerActivation(data) {
  return request({
    url: "/api/activation/register",
    method: "post",
    data,
    silentError: true
  });
}

export function sendVerifyBindingMac(data) {
  return request({
    url: "/api/hp-user/send-verify-binding-mac",
    method: "post",
    data
  });
}

// ACTIVATION ONLY-------------------------------------------------- END